export const allInvoiceHeadCells = {
    invoiceId: {
        id: 'invoiceId',
        label: "Invoice Id",
        showInView: true,
    },
    orderId: {
        id: 'orderId',
        label: "Order Id",
        showInView: true,
    },
    email: {
        id: 'email',
        label: "Email",
        showInView: true,
    },
    phone: {
        id: 'phone',
        label: "Phone",
        showInView: true,
    },
    createdAt: {
        id: 'createdAt',
        label: "Created At",
        showInView: true,
        type: 'date'
    },
    paymentStatus: {
        id: 'paymentStatus',
        label: "Payment Status",
        showInView: true,
        showComponent: true
    }
}

export const paidInvoiceHeadCells = {
    invoiceId: {
        id: 'invoiceId',
        label: "Invoice Id",
        showInView: true,
    },
    orderId: {
        id: 'orderId',
        label: "Order Id",
        showInView: true,
    },
    email: {
        id: 'email',
        label: "Email",
        showInView: true,
    },
    offerCode: {
        id: 'offerCode',
        label: "Offer Code",
        showInView: true,
    },
    offerIdentifier: {
        id: 'offerIdentifier',
        label: "Offer Identifier",
        showInView: true,
    },
    phone: {
        id: 'phone',
        label: "Phone",
        showInView: true,
    },
    createdAt: {
        id: 'createdAt',
        label: "Created At",
        showInView: true,
        type: 'date'
    },
}